import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=2c809bfb&scoped=true"
import script from "./DataBoard.vue?vue&type=script&lang=js"
export * from "./DataBoard.vue?vue&type=script&lang=js"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=2c809bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c809bfb",
  null
  
)

export default component.exports